export default __webpack_public_path__ + "img/29855e28369727a56e3ec075cf9b721f.svg";